import { render, staticRenderFns } from "./CopyRates.vue?vue&type=template&id=b6caeb86&"
import script from "./CopyRates.vue?vue&type=script&lang=js&"
export * from "./CopyRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports